// Auth and user profile
export const LOGIN = 'api/v1/user/login.php'
export const USER_PROFILE = 'api/v1/user/user_profile.php'

// Master Data
export const GET_BU = 'api/v1/stock/dashboard/data/get_bu.php'
export const GET_STORE = 'api/v1/stock/dashboard/data/get_store.php'
export const GET_CATEGORY =
  'api/v1/stock/dashboard/data/get_categories.php'
export const GET_CATEGORY_STORE =
  'api/v1/stock/dashboard/data/get_categories_store.php'
export const GET_CATEGORIES =
  'api/v1/stock/dashboard/data/get_categories_all.php'

// Job
export const CREATE_JOB = 'api/v1/stock/dashboard/add_job.php'
export const UPDATE_JOB = 'api/v1/stock/dashboard/update_job.php'
export const UPDATE_STORE_DETAIL =
  'api/v1/stock/dashboard/update_store_detail.php'
export const DELETE_JOB = 'api/v1/stock/dashboard/delete_job.php'
export const GET_JOB_LIST = 'api/v1/stock/dashboard/job_list.php'
export const GET_JOB_DETAIL = 'api/v1/stock/dashboard/job_detail.php'
export const GET_STORE_DETAIL =
  'api/v1/stock/dashboard/job_store_detail.php'
export const GET_ALL_ACTIVITY =
  'api/v1/stock/dashboard/all_activity.php'
export const GET_STORE_DETAIL_LOG =
  'api/v1/stock/dashboard/job_store_detail_log.php'

// Report
export const REPORT_STOCK_CHECKED =
  'api/v1/stock/dashboard/report/stock_checked.php'
export const REPORT_ACTIVITY_LOG =
  'api/v1/stock/dashboard/report/activity_log.php'
export const REPORT_CHECKED_BY_DATE =
  'api/v1/stock/dashboard/report/stock_checked_by_date.php'
export const REPORT_JOB_RESULT =
  'api/v1/stock/dashboard/report/job_result.php'
export const REPORT_STOCK_ACTIVITY_BY_DATE =
  'api/v1/stock/dashboard/report/stock_activity_by_date.php'
export const REPORT_STOCK_PROGRESS =
  'api/v1/stock/dashboard/report/stock_progress.php'
export const REPORT_STOCK_PROGRESS_BY_DATE =
  'api/v1/stock/dashboard/report/employee_checked_stock_summary_condition.php'
export const REPORT_EMPLOYEES_NOT_CHECKED_STOCK =
  'api/v1/stock/dashboard/report/lazy_emp.php'

// Stock
export const GET_STOCK_LIST = 'api/v1/stock/card/get_stock_list.php'
export const GET_STOCK_DETAIL =
  'api/v1/stock/card/get_stock_detail.php'

// AI Image Detection
export const GET_AI_IMAGE_DETECTION =
  'api/v1/stock/dashboard/ai_explanation.php'
export const UPDATE_STATUS_AI_IMAGE_DETECTION =
  'api/v1/stock/dashboard/ai_update_status.php'
